import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { Button } from 'lib/ui/components/Button'
import { Container } from './styled'

export const NoMatch = () => {
  const history = useHistory()

  const handleRedirect = () => {
    history.push('/')
  }

  return (
    <Container>
      <div>
        <h2>
          <FormattedMessage
            id='notFound.title'
          />
        </h2>
        <p>
          <FormattedMessage
            id='notFound.text'
          />
        </p>
        <p>
          Error 404
        </p>
        <Button
          className='button'
          onClick={handleRedirect}
        >
          <p>
            <FormattedMessage
              id='notFound.button'
            />
          </p>
        </Button>
      </div>
    </Container>
  )
}
